<template>
  <div
    class="decoration-config-collapse-title"
  >
    <div class="decoration-config-collapse_arrow">
      <i :class="[item.name === active ? 'el-icon-caret-bottom': 'el-icon-caret-right']"></i>
    </div>
    <template v-if="!edit">
      <span>{{ item.title }}</span>
      <span v-if="item.showButton">{{ `(${getCurrentSelectedNumber(item.name)}/${item.limit})` }}</span>
      <mk-tooltip
        effect="dark"
        content="点击即可编辑"
        placement="right"
      >
        <ds-iconfont
          v-if="item.showEdit && item.name === active"
          icon-class="icon-mk-bianji"
          @click.stop="handleEditClick"
        >
        </ds-iconfont>
      </mk-tooltip>
    </template>
    <div
      v-else
      class="decoration-config-collapse_edit"
      @click.stop
    >
      <mk-form
        :inline="true"
        size="mini"
      >
        <mk-form-item>
          <el-input
            ref="inputTitle"
            v-model="title"
            height="28"
            width="200"
            maxlength="10"
            show-word-limit
            @submit.native.prevent
          >
          </el-input>
        </mk-form-item>
        <mk-form-item>
          <mk-button-biz
            type="text"
            size="mini"
            height="28"
            @click.stop="handleOnSaveClick"
          >
            保存
          </mk-button-biz>
          <mk-button-biz
            type="text"
            size="mini"
            height="28"
            @click.stop="handleOnCancelClick"
          >
            取消
          </mk-button-biz>
        </mk-form-item>
      </mk-form>
    </div>
  </div>
</template>

<script>
import { CARDAPIS } from '@api'
export default {
  name: 'DecorationConfigCollapseTitle',
  props: {
    data: {
      type: Object,
      default () {
        return {}
      }
    },
    item: {
      type: Object,
      default () {
        return {}
      }
    },
    active: {
      type: String,
      default: ''
    }
  },
  data () {
    return {
      title: this.item.title,
      edit: false
    }
  },
  watch: {
    active (value) {
      if (value === '') {
        this.edit = false
      }
    }
  },
  methods: {
    handleEditClick () {
      this.title = this.item.title
      this.edit = true
    },
    handleOnSaveClick () {
      let params = {
        configType: 'card',
        fieldKey: this.item.name,
        fieldValue: this.title
      }
      this.companyCardConfigCardComponentPost(params)
    },
    handleOnCancelClick () {
      this.edit = false
    },
    handleOnTitleFocus (event) {
      event.preventDefault()
    },
    async companyCardConfigCardComponentPost (params) {
      const { success, msg } = await CARDAPIS.CardApi.companyCardConfigCardComponentPost(params)
      if (success) {
        this.$message.success('保存标题成功！')
        this.$emit('on-save-title-click', {
          ...this.item,
          title: this.title
        })
        this.edit = false
      } else {
        this.$message.error(msg)
      }
    },
    getCurrentSelectedNumber (active) {
      const currentList = this.data[active] ? this.data[active] : []
      return currentList.length
    }
  }
}
</script>

<style lang="scss" scoped>
.decoration-config-collapse-title {
  flex: 1;

  .decoration-config-collapse_edit {
    display: inline-block;
    margin-left: 10px;
  }

  /deep/.el-form-item--mini.el-form-item {
    margin-top: 8px;
    margin-bottom: 0;
  }

  /deep/.el-form--inline {
    // margin-top: 9px;
    height: 44px;
  }

  .decoration-config-collapse_arrow {
    display: inline-block;
    height: 44px;
    margin-right: 9px;
  }

  .icon-mk-bianji {
    font-size: 13px;
    margin-left: 10px;
  }

  .icon-mk-bianji:hover {
    color: #009cff;
  }
}
</style>
